import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Container, Row, Col, ListGroup } from "react-bootstrap";
import services from "../data/services";
import "../styles/service-detail.css"
import { useEffect } from "react";

export default function ServiceDetail() {
  const { serviceId } = useParams();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }, [pathname]);

  const activeService =
    services.find(s => s.id === serviceId) || services[0];

  return (
    <section className="service-detail-section py-5">
      <Container>
        <Row>
          <Col lg={3} className="mb-4 mb-lg-0">
            <div className="service-nav">
              <ListGroup variant="flush">
                {services.map(service => (
                  <ListGroup.Item
                    key={service.id}
                    action
                    active={service.id === activeService.id}
                    onClick={() =>
                      navigate(`/services/${service.id}`)
                    }
                  >
                    {service.title}
                  </ListGroup.Item>
                ))}
              </ListGroup>
            </div>
          </Col>

          <Col lg={9}>
            <h1 className="mb-3">{activeService.title}</h1>

            <Row className="align-items-center mb-4">
              <Col md={12}>
                <p className="lead">
                  {activeService.description}
                </p>
              </Col>
            </Row>

            <h5 className="mb-3">What We Offer</h5>
            <ul className="service-points">
              {activeService.points.map((point, idx) => (
                <li key={idx}>{point}</li>
              ))}
            </ul>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
